import "./App.css";

const sections = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
  { id: "policy", label: "Policies" },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="primary-nav">
        <span className="logo">Dark Web Analysis</span>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <header className="hero" id="about" style={{ backgroundImage: 'url("/images/hero-bg.jpg")' }}>
        <img 
          src="/uploads/hero.jpg" 
          alt="Dark Web Analysis - In-depth analysis of dark web marketplaces and threats" 
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} 
        />
        <p className="eyebrow">Dark Web Analysis · Your Trusted Source</p>
        <h1>Welcome to Dark Web Analysis</h1>
        <p className="lede">
          At Dark Web Analysis, we provide insightful analysis and resources to help you navigate the complexities of the dark web. Our mission is to empower individuals and organizations with the knowledge they need to stay safe and informed. The dark web can be a daunting place, filled with risks and uncertainties. However, with the right tools and information, you can protect yourself and your assets. Our team of experts is dedicated to researching and analyzing the dark web to bring you the most relevant and actionable insights.
        </p>
        <p>
          We understand that the digital landscape is constantly evolving, and staying ahead of potential threats is crucial. That's why we offer a range of services designed to keep you informed and prepared. From comprehensive reports to real-time alerts, our offerings are tailored to meet your needs. Join us as we explore the depths of the dark web and uncover the information that matters most to you.
        </p>
        <div className="cta-row">
          <a href="/blog" className="cta-button">Read Our Blog</a>
          <a href="/resources" className="secondary">Explore Resources</a>
        </div>
      </header>

      <section className="cards" id="services">
        <article>
          <h2>Comprehensive Reports</h2>
          <p>
            Our in-depth reports cover the latest trends and threats on the dark web, providing you with the insights necessary to protect your digital assets. Each report is meticulously crafted to ensure you have the most accurate and up-to-date information.
          </p>
        </article>
        <article>
          <h2>Expert Guidance</h2>
          <p>
            Our team of experts is available to offer personalized guidance and strategies tailored to your specific needs and concerns. We believe that informed decisions are the best decisions.
          </p>
        </article>
        <article>
          <h2>Real-Time Alerts</h2>
          <p>
            Stay informed with our real-time alerts on emerging threats and vulnerabilities that could impact your organization. Our alert system is designed to keep you one step ahead.
          </p>
        </article>
        <article>
          <h2>Community Engagement</h2>
          <p>
            Join our community to share insights, ask questions, and learn from others who are navigating the dark web landscape. Together, we can create a safer online environment.
          </p>
        </article>
      </section>

      <section className="resources" id="resources">
        <h2>Latest Insights</h2>
        <div className="resource-card">
          <h3><a href="/blog/post1">Understanding Dark Web Marketplaces</a></h3>
          <p>Explore the dynamics of dark web marketplaces and how they operate. This post delves into the intricacies of these hidden platforms.</p>
        </div>
        <div className="resource-card">
          <h3><a href="/blog/post2">Protecting Your Identity Online</a></h3>
          <p>Learn effective strategies to safeguard your identity from dark web threats. This article provides practical tips for maintaining your privacy.</p>
        </div>
        <div className="resource-card">
          <h3><a href="/blog/post3">The Rise of Cybercrime</a></h3>
          <p>Analyze the increasing trends in cybercrime and what it means for you. Stay informed about the latest threats and how to combat them.</p>
        </div>
      </section>

      <section className="contact" id="contact">
        <div>
          <h2>Contact Us</h2>
          <p>If you have questions or need assistance, please reach out to us. We are here to help you navigate the complexities of the dark web.</p>
          <ul>
            <li>Email: support@darkwebanalysis.com</li>
            <li>Phone: (123) 456-7890</li>
            <li>Location: Your City, USA</li>
          </ul>
        </div>
        <form>
          <label>
            Name
            <input type="text" placeholder="Jane Doe" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message
            <textarea rows={4} placeholder="How can we help?" required />
          </label>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <section className="policies" id="policy">
        <h2>Policies & Compliance</h2>
        <p>
          This site provides essential compliance resources. Customize the linked pages in{" "}
          <code>public/</code> to match your organization.
        </p>
        <ul className="policy-links">
          <li><a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          <li><a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
          <li><a href="/contact" target="_blank" rel="noreferrer">Contact</a></li>
          <li><a href="/about" target="_blank" rel="noreferrer">About</a></li>
        </ul>
      </section>

      <footer>
        <p className="disclaimer">Informational only. Please consult a professional for specific advice.</p>
      </footer>

      <div id="adsense" className="adsense-slot">
        <p>AdSense placeholder — replace with your ad code.</p>
      </div>
    </div>
  );
}

export default App;